import {取込ファイル明細型} from '@/type/external/file/取込ファイル明細';

export class 取込ファイル型 {
  public ファイル名: string;
  public 取込ファイル明細一覧: 取込ファイル明細型[];
  public 確定区分: string;
  public 削除フラグ: string;
  public 更新バージョン: number;

  constructor(
    ファイル名: string,
    取込ファイル明細一覧: 取込ファイル明細型[],
    確定フラグ: string,
    削除フラグ: string,
    更新バージョン: number) {
    this.ファイル名 = ファイル名;
    this.取込ファイル明細一覧 = 取込ファイル明細一覧;
    this.確定区分 = 確定フラグ;
    this.削除フラグ = 削除フラグ;
    this.更新バージョン = 更新バージョン;
  }

  public 確定済みである(): boolean {
    return this.確定区分 === '確定済み';
  }

  public 取消済みである(): boolean {
    return this.削除フラグ === '削除';
  }

  public ファイルを確定できない(): boolean {
    return this.isEmpty() || this.確定済みである();
  }

  public 確定取消できない() {
    return !this.確定済みである() || this.取消済みである();
  }

  public isEmpty(): boolean {
    return this.取込ファイル明細一覧.length === 0;
  }
}
